/**
 * Auth user role constants
 *
 * JWT payload contains an 'auth' or 'role' field with one of these values.
 * Used to determine user authentication status.
 *
 * Roles:
 * - ANONYMOUS: User not logged in (default state)
 * - USER: Authenticated customer
 * - EMPLOYEE: Authenticated Pixum employee
 */
export const AUTH_USER_ROLE = {
  ANONYMOUS: 'ROLE_ANONYMOUS',
  USER: 'ROLE_USER',
  EMPLOYEE: 'ROLE_EMPLOYEE',
} as const;
